module.exports = __webpack_public_path__ + "img/header-engagementRingsSignature@2x.af62c02.webp";